import { useQuery } from 'react-query';
import { matchService } from 'match/services/matchService';

export function useMatchQuery(matchId) {
  return useQuery(['matchService_getMatch'], () => matchService.getMatch({ matchId }));
}
